import type * as Types from '../../types';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import document from './userTasteProfileQuery.gql';
import type * as ApolloReactCommon from '~/lazy_apollo/client';
import * as ApolloReactHooks from '~/lazy_apollo/client';
const defaultOptions = {} as const;
export type UserTasteProfileDishFragment_MenuItem_featuredPhoto_MenuItemPosPhoto = {
  __typename: 'MenuItemPosPhoto',
  id: number,
  photoUrl?: string | null
};

export type UserTasteProfileDishFragment_MenuItem_featuredPhoto_Photo = {
  __typename: 'Photo',
  id: number,
  photoUrl?: string | null
};

export type UserTasteProfileDishFragment_MenuItem_featuredPhoto =
  | UserTasteProfileDishFragment_MenuItem_featuredPhoto_MenuItemPosPhoto
  | UserTasteProfileDishFragment_MenuItem_featuredPhoto_Photo
;

export type UserTasteProfileDishFragment_MenuItem_location_RestaurantLocation = {
  __typename: 'RestaurantLocation',
  id: number,
  city: string,
  countryName: string,
  state?: string | null
};

export type UserTasteProfileDishFragment_MenuItem_restaurant_Restaurant = {
  __typename: 'Restaurant',
  id: number,
  name: string
};

export type UserTasteProfileDishFragment_MenuItem_restaurantLink_MenuItemRestaurantLink = {
  __typename: 'MenuItemRestaurantLink',
  kind: Types.MenuItemRestaurantLinkKind,
  url: string
};

export type UserTasteProfileDishFragment = {
  __typename: 'MenuItem',
  id: number,
  displayName: string,
  featuredPhoto?: UserTasteProfileDishFragment_MenuItem_featuredPhoto | null,
  location?: UserTasteProfileDishFragment_MenuItem_location_RestaurantLocation | null,
  restaurant: UserTasteProfileDishFragment_MenuItem_restaurant_Restaurant,
  restaurantLink?: UserTasteProfileDishFragment_MenuItem_restaurantLink_MenuItemRestaurantLink | null
};

export type UserTasteProfileQuery_userTasteProfile_UserTasteProfile_traits_UserTasteTrait = {
  __typename: 'UserTasteTrait',
  feature: string,
  isConfident: boolean,
  level: Types.UserTasteTraitLevel
};

export type UserTasteProfileQuery_userTasteProfile_UserTasteProfile_lovedMenuItemMatches_MenuItemUserTasteMatch_menuItem_MenuItem = {
  __typename: 'MenuItem',
  id: number,
  displayName: string,
  featuredPhoto?: UserTasteProfileDishFragment_MenuItem_featuredPhoto | null,
  location?: UserTasteProfileDishFragment_MenuItem_location_RestaurantLocation | null,
  restaurant: UserTasteProfileDishFragment_MenuItem_restaurant_Restaurant,
  restaurantLink?: UserTasteProfileDishFragment_MenuItem_restaurantLink_MenuItemRestaurantLink | null
};

export type UserTasteProfileQuery_userTasteProfile_UserTasteProfile_lovedMenuItemMatches_MenuItemUserTasteMatch_traits_UserTasteTrait = {
  __typename: 'UserTasteTrait',
  feature: string,
  isConfident: boolean,
  level: Types.UserTasteTraitLevel
};

export type UserTasteProfileQuery_userTasteProfile_UserTasteProfile_lovedMenuItemMatches_MenuItemUserTasteMatch = {
  __typename: 'MenuItemUserTasteMatch',
  menuItem: UserTasteProfileQuery_userTasteProfile_UserTasteProfile_lovedMenuItemMatches_MenuItemUserTasteMatch_menuItem_MenuItem,
  traits: Array<UserTasteProfileQuery_userTasteProfile_UserTasteProfile_lovedMenuItemMatches_MenuItemUserTasteMatch_traits_UserTasteTrait>
};

export type UserTasteProfileQuery_userTasteProfile_UserTasteProfile_pickedMenuItemMatches_MenuItemUserTasteMatch_menuItem_MenuItem = {
  __typename: 'MenuItem',
  id: number,
  displayName: string,
  featuredPhoto?: UserTasteProfileDishFragment_MenuItem_featuredPhoto | null,
  location?: UserTasteProfileDishFragment_MenuItem_location_RestaurantLocation | null,
  restaurant: UserTasteProfileDishFragment_MenuItem_restaurant_Restaurant,
  restaurantLink?: UserTasteProfileDishFragment_MenuItem_restaurantLink_MenuItemRestaurantLink | null
};

export type UserTasteProfileQuery_userTasteProfile_UserTasteProfile_pickedMenuItemMatches_MenuItemUserTasteMatch_traits_UserTasteTrait = {
  __typename: 'UserTasteTrait',
  feature: string,
  isConfident: boolean,
  level: Types.UserTasteTraitLevel
};

export type UserTasteProfileQuery_userTasteProfile_UserTasteProfile_pickedMenuItemMatches_MenuItemUserTasteMatch = {
  __typename: 'MenuItemUserTasteMatch',
  menuItem: UserTasteProfileQuery_userTasteProfile_UserTasteProfile_pickedMenuItemMatches_MenuItemUserTasteMatch_menuItem_MenuItem,
  traits: Array<UserTasteProfileQuery_userTasteProfile_UserTasteProfile_pickedMenuItemMatches_MenuItemUserTasteMatch_traits_UserTasteTrait>
};

export type UserTasteProfileQuery_userTasteProfile_UserTasteProfile = {
  __typename: 'UserTasteProfile',
  id: number,
  comparisonsCount: number,
  lovesCount: number,
  traits: Array<UserTasteProfileQuery_userTasteProfile_UserTasteProfile_traits_UserTasteTrait>,
  lovedMenuItemMatches: Array<UserTasteProfileQuery_userTasteProfile_UserTasteProfile_lovedMenuItemMatches_MenuItemUserTasteMatch>,
  pickedMenuItemMatches: Array<UserTasteProfileQuery_userTasteProfile_UserTasteProfile_pickedMenuItemMatches_MenuItemUserTasteMatch>
};

export type UserTasteProfileQuery_Query = {
  __typename?: 'Query',
  userTasteProfile: UserTasteProfileQuery_userTasteProfile_UserTasteProfile
};


export type UserTasteProfileQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type UserTasteProfileQuery = UserTasteProfileQuery_Query;

export const UserTasteProfileDishFragmentDoc = /*#__PURE__*/ document as unknown as DocumentNode<UserTasteProfileDishFragment, unknown>;
export const UserTasteProfileDocument = /*#__PURE__*/ document as unknown as DocumentNode<UserTasteProfileQuery, UserTasteProfileQueryVariables>;

/**
 * __useUserTasteProfileQuery__
 *
 * To run a query within a React component, call `useUserTasteProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserTasteProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserTasteProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserTasteProfileQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UserTasteProfileQuery, UserTasteProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserTasteProfileQuery, UserTasteProfileQueryVariables>(UserTasteProfileDocument, options);
      }
export function useUserTasteProfileLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserTasteProfileQuery, UserTasteProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserTasteProfileQuery, UserTasteProfileQueryVariables>(UserTasteProfileDocument, options);
        }
// @ts-ignore
export function useUserTasteProfileSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UserTasteProfileQuery, UserTasteProfileQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserTasteProfileQuery, UserTasteProfileQueryVariables>;
export function useUserTasteProfileSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserTasteProfileQuery, UserTasteProfileQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserTasteProfileQuery | undefined, UserTasteProfileQueryVariables>;
export function useUserTasteProfileSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserTasteProfileQuery, UserTasteProfileQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UserTasteProfileQuery, UserTasteProfileQueryVariables>(UserTasteProfileDocument, options);
        }
export type UserTasteProfileQueryHookResult = ReturnType<typeof useUserTasteProfileQuery>;
export type UserTasteProfileLazyQueryHookResult = ReturnType<typeof useUserTasteProfileLazyQuery>;
export type UserTasteProfileSuspenseQueryHookResult = ReturnType<typeof useUserTasteProfileSuspenseQuery>;
export type UserTasteProfileQueryResult = ApolloReactCommon.QueryResult<UserTasteProfileQuery, UserTasteProfileQueryVariables>;